import { PropsWithChildren } from 'react'
import { Chip } from '@pogokid/mui'
import styles from './Kbd.module.css'
import {
  NavigatorOs,
  useNavigatorOs,
} from '~m/designSystem/components/Kbd/util.ts'

interface KbdProps {
  mod?: boolean
}

export function Kbd({
  mod,
  children,
}: PropsWithChildren<KbdProps>) {
  return (
    <Chip
      className={styles.Kbd}
      component="kbd"
      aria-hidden="true"
      variant="filled"
      size="small"
      label={
        <>
          {mod && <KbdMod />}
          {children}
        </>
      }
    />
  )
}

export function KbdMod() {
  const os = useNavigatorOs()
  const modifier = os === NavigatorOs.Mac ? '⌘' : 'ctrl'
  return <span className={styles.Kbd__modifier}>{modifier}</span>
}
